import { useQuery } from '@tanstack/react-query';
import { UserApiClient } from 'api';

export const useAdminUser = (id?: string) => {
  return useQuery({
    queryKey: ['adminUsers', id],
    queryFn: () => UserApiClient.getAdminUserById(id as string),
    enabled: !!id,
  });
};
